import React from 'react';
import l1 from '../assets/icons/one-stop.png';
import l2 from '../assets/icons/continuous-image.png'
import l3 from '../assets/icons/strong-tech.png'
import l4 from '../assets/icons/priority-to-client.png'
import wcu1 from '../assets/homeWCU/image1.png'
import wcu2 from '../assets/homeWCU/image2.png'
import wcu3 from '../assets/homeWCU/image3.png'
import wcu4 from '../assets/homeWCU/image4.png'

const listItems = [
    {
        icon: l1,
        text: 'One-stop Solutions',
    },
    {
        icon: l2,
        text: 'Continuous Improvement'
    },
    {
        icon: l3,
        text: 'Strong Technical Expertise'
    },
    {
        icon: l4,
        text: 'Priority to Client Satisfaction'
    }
];

const WhyChooseUs = () => {
    return (
        <div className='w-full flex flex-col items-center gap-10 px-4 py-10 relative'>
            <p className='text-[24px] md:text-[32px] font-semibold text-center'>
                Why to choose us
            </p>

            <div className='flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-[50px] w-full max-w-7xl'>

                {/* Left Section */}
                <div className='w-full lg:w-2/5 flex flex-col gap-6 px-2 md:px-8'>
                    <p className='text-[22px] md:text-[28px] font-medium text-left'>
                        "Why eSparse Matrix Solutions is Your Ideal Technology Partner"
                    </p>

                    <div className='flex flex-col gap-5 list-none'>
                        {listItems.map((item, index) => (
                            <div key={index} className='flex items-center gap-6'>
                                {item.icon && (
                                    <div className='bg-[#1E90FF] w-14 h-14 rounded-full flex items-center justify-center'>
                                        <img src={item.icon} alt={`icon-${index}`} className='w-8 h-8 object-contain' />
                                    </div>
                                )}
                                <li className='text-[16px] md:text-[20px] font-semibold leading-snug'>
                                    {item.text}
                                </li>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right Section */}
                <div className='w-full lg:w-3/5 relative flex justify-center'>
                    {/* Background shape */}
                    <div className="bg-[#EAEEFB] w-full h-[300px] md:h-[350px] lg:h-[400px] absolute bottom-0 right-0 z-0 rounded-lg"></div>

                    {/* Image stack */}
                    <div className='relative w-full max-w-[540px] h-[400px] md:h-[500px] z-10'>
                        <img src={wcu1} alt='wcu1' className='w-[120px] h-[170px] md:w-[178px] md:h-[254px] absolute top-0 left-0' />
                        <img src={wcu2} alt='wcu2' className='w-[220px] h-[160px] md:w-[335px] md:h-[223px] absolute bottom-8 left-4' />
                        <img src={wcu3} alt='wcu3' className='w-[240px] h-[180px] md:w-[347px] md:h-[231px] absolute top-0 right-0' />
                        <img src={wcu4} alt='wcu4' className='w-[120px] h-[170px] md:w-[178px] md:h-[254px] absolute bottom-0 right-0' />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WhyChooseUs;
